// supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://yebsltnxixvfrogoplkm.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InllYnNsdG54aXh2ZnJvZ29wbGttIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjcwMDUzNTQsImV4cCI6MjA0MjU4MTM1NH0.lmJicCCGXQRrh218-_8SIyYn6EeTJv7I_fjOTKIN18I";

export const supabase = createClient(supabaseUrl, supabaseKey);
